export function sortItems(keys, getSortKey) {
    let itemsBySortKey = {},
        key,
        item,
        i;

    for (i = 0; i < this.items.length; i++) {
        item = this.items[i];
        key = getSortKey(item);
        itemsBySortKey[key] = item;
    }

    for (i = 0; i < keys.length; i++) {
        key = keys[i];
        item = itemsBySortKey[key];
        this.items[i] = item;
    }
}

export function bindSchoolBlocksDraggabillyEvents(draggie) {
    const { sb_delay } = require("../../utils/functions");

    let pckryInstance = this;

    draggie.on('dragStart', this.handleDraggabilly.dragStart);
    draggie.on('dragMove', this.handleDraggabilly.dragMove);
    draggie.on('dragEnd', function () {
        let draggieInstance = this,
            draggedItem = pckryInstance.getItem(draggieInstance.element),
            spaces,
            i,
            x,
            y;

        pckryInstance.layout();

        spaces = pckryInstance.packer.spaces;

        x = draggedItem.rect.x;
        y = draggedItem.rect.y;

        for (i = 0; i < spaces.length; i++) {
            if ((x === spaces[i].x) &&  // the block is in the same column as the space
                (draggedItem.rect.width === spaces[i].width) && // the block is the same width as the space
                (y > spaces[i].y) // the block is lower on the y-axis than the space begins (meaning there is open
                // space above the block).
            ) {
                if ((spaces[i].height === Number.POSITIVE_INFINITY) || (y === (spaces[i].y + spaces[i].height))) {
                    draggedItem.positionPlaceRect(x, spaces[i].y);
                    break;
                }
            }
        }

        // For some reason, Packery doesn't tell the front end when a drag was cancelled (for
        // example: trying to drop on a stamped item).  This adds a custom flag to the draggedItem
        // that gets passed to the dragItemPositioned event handler so we know whether the grid
        // should be saved or not.
        draggedItem.sbDragWasCancelled = (
            draggedItem.placeRect.x === draggieInstance.startPosition.x
            && draggedItem.placeRect.y === draggieInstance.startPosition.y
        );

        sb_delay(function () {
            pckryInstance.handleDraggabilly.dragEnd.apply(draggieInstance);
        }, 10);
    });
}
